import PropTypes from "prop-types";
import React, { Component } from "react";

export default class LoadingSpinner extends Component {
  render() {
    return this.props.open ? (
      <div className="spinner-wrapper">
        <svg className="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle className="path" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30" />
        </svg>
      </div>
    ) : null;
  }
}

LoadingSpinner.propTypes = {
  open: PropTypes.bool
};
